module.exports = __webpack_public_path__ + "e3e8c5f4f4ab09759fd8220e9bd8c586.svg";